import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { getFlowKey } from '../routing/getFlowKey';
export const getNewUserHubletChoice = () => {
  return noAuthApiClient.post('signup/v1/location/new-user-available-hublets', {
    data: {
      flowKey: getFlowKey()
    }
  });
};